import React, { memo } from 'react'
import { Container } from '@mui/material'

import PageTitle from '../shared/pageTitle/PageTitle'
import Text from '../text/Text'

const RewardBoxes = ({ t }) => {
  return (
    <Container maxWidth='md'>
      <PageTitle
        title={t('reward-box.reward-boxes')}
        desc={t('reward-box.reward-boxes-desc')}
      />
      <Text color='invert' variant='subtitle1' label={t('shop.soon')} />
    </Container>
  )
}

export default memo(RewardBoxes)
